import { useLocation } from "@tanstack/react-router";
import type { ParsedQuery } from "query-string";
import { parse } from "query-string";
import { useMemo } from "react";

/**
 * @deprecated Use TanStack Router's `useSearch` to read search params:
 *
 * ```tsx
 * const { tab } = useSearch({ from: "/_protected/example" });
 * ```
 */
export const useRouterQueryParams = (): ParsedQuery<string> => {
  const searchStr = useLocation({ select: location => location.searchStr });

  return useMemo(() => parse(searchStr), [searchStr]);
};

/**
 * @deprecated Use TanStack Router's `useSearch`.
 * See `useRouterQueryParams` deprecation note.
 */
export const useTanstackRouterQueryParams = useRouterQueryParams;
